/**
 * Returns the default font size of the document. Optionally, the parameter parent element.
 *
 * @param {*} parent Optional parent. Default value is body.
 * @returns
 */
function getDefaultFontSize(parent?: any) {
	parent = parent || document.body;
	const temp = document.createElement('div');

	temp.style.cssText =
		'display:inline-block; padding:0; line-height:1; position:absolute; visibility:hidden; font-size:1em';

	temp.appendChild(document.createTextNode('M'));
	parent.appendChild(temp);
	const fontSize = temp.offsetHeight;
	parent.removeChild(temp);
	return fontSize;
}

const defaultFontSize = getDefaultFontSize();

enum Breakpoints {
	XS = 35.938 * defaultFontSize,
	SM = 36 * defaultFontSize,
	MD = 48 * defaultFontSize,
	LG = 62 * defaultFontSize,
	XLG = 75 * defaultFontSize,
}

export default Breakpoints;

export function slugify(text) {
	return text
		.toString()
		.toLowerCase()
		.replace(/\s+/g, '-') // Replace spaces with -
		.replace(/[^\w\-]+/g, '') // Remove all non-word chars
		.replace(/\-\-+/g, '-') // Replace multiple - with single -
		.replace(/^-+/, '') // Trim - from start of text
		.replace(/-+$/, ''); // Trim - from end of text
}
